// extracted by mini-css-extract-plugin
export var active = "_1m-d";
export var blink = "_1m-e";
export var container = "_1m-5";
export var controls = "_1m-0";
export var controlsRight = "_1m-1";
export var fakeCursor = "_1m-c";
export var hidden = "_1m-b";
export var quillContainerSmall = "_1m-7";
export var quillEditor = "_1m-6";
export var quillEditorSmall = "_1m-8";
export var quillFormatButtons = "_1m-a";
export var quillToolbar = "_1m-9";
export var removePadding = "_1m-2";
export var state = "_1m-3";
export var stateTitle = "_1m-4";